import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  floristProduct: null,
  inventoryProduct: null,
  refetchedAfterUpdate: true,
};

const slice = createSlice({
  name: 'products',
  initialState: initialState,
  reducers: {
    setProductsState: (state, { payload }) => {
      if (payload.isFlorist) {
        return {
          ...state,
          floristProduct: payload.data,
        };
      } else {
        return {
          ...state,
          inventoryProduct: payload.data,
        };
      }
    },

    setProductsProgress: (state, { payload }) => {
      if (payload.isFlorist) {
        const itemToBeUpdated = state.floristProduct;
        const updatedItem = {
          ...itemToBeUpdated,
          progress: payload.progress,
        };
        return {
          ...state,
          floristProduct: updatedItem,
        };
      } else {
        const itemToBeUpdated = state.inventoryProduct;
        const updatedItem = {
          ...itemToBeUpdated,
          progress: payload.progress,
        };
        return {
          ...state,
          inventoryProduct: updatedItem,
        };
      }
    },

    setProductsUploading: (state, { payload }) => {
      if (payload.isFlorist) {
        const itemToBeUpdated = state.floristProduct;
        const updatedItem = {
          ...itemToBeUpdated,
          uploading: payload.uploading,
        };
        return {
          ...state,
          floristProduct: updatedItem,
        };
      } else {
        const itemToBeUpdated = state.inventoryProduct;
        const updatedItem = {
          ...itemToBeUpdated,
          uploading: payload.uploading,
        };
        return {
          ...state,
          inventoryProduct: updatedItem,
        };
      }
    },

    setRefetchedAfterUpdate: (state, { payload }) => {
      return {
        ...state,
        refetchedAfterUpdate: payload.refetchedAfterUpdate,
      };
    },

    resetProductsState: (state) => {
      return {
        ...state,
        inventoryProduct: null,
        floristProduct: null,
      };
    },
  },
});

export const {
  setProductsState,
  setProductsProgress,
  setProductsUploading,
  setRefetchedAfterUpdate,
  resetProductsState,
} = slice.actions;

export default slice.reducer;
